import * as React from 'react';
import { FileTextIcon } from 'lucide-react';
import { Card, CardContent } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';
import { cn } from 'lib/utils';

import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';

type Props = React.ComponentProps<typeof CardContent>

export const PageHeader = ({
                             className,
                             children,
                             ...props
                           }: Props) => {
  const { invoice } = useInvoiceStore();

  const invoiceNumber = React.useMemo(() => {
    return [invoice?.infnfeIdeNnf, invoice?.infnfeIdeSerie].join('-');
  }, [invoice]);

  return (
    <Card>
      <CardContent {...props} className={cn('flex items-center pt-6', className)}>
        <div className={'flex items-center gap-2'}>
          <FileTextIcon className={'w-6 h-6'} />
          {!invoice && <Skeleton className={'w-40 h-5'} />}
          {invoice?.id && (
            <div className={'flex items-center gap-2'}>
              <h1 className={'font-GilroySemibold text-lg'}>Nota Fiscal</h1>
              <span className={'font-light'}>{invoiceNumber}</span>
            </div>
          )}
        </div>
        <div className={'flex items-center gap-2 shrink-0 ml-auto'}>
          {children}
        </div>
      </CardContent>
    </Card>
  );
};
